<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="复核状态"
                        prop="review_status">
            <el-select v-model="search.review_status"
                       placeholder="请选择复核状态"
                       class="width-max"
                       clearable>
              <el-option v-for="(label, value) in reviewStatusMap"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复核人"
                        prop="adminid">
            <remote-select class="width-max"
                           v-model="search.adminid"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入复核人进行搜索"
                           :query-request="getPlatformUsersIndex"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="工单审核人"
                        prop="intern_user_id">
            <remote-select class="width-max"
                           v-model="search.intern_user_id"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入工单审核人进行搜索"
                           :query-request="getPlatformUsersIndex"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="审核通过时间"
                        prop="reviewedtime_range">
            <el-date-picker class="width-max"
                            v-model="search.reviewedtime_range"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户"
                        prop="customerid">
            <remote-select class="width-max"
                           v-model="search.customerid"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入客户名称搜索"
                           :query-request="getCustomerTable"
                           :find-request="getCustomerDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="工单ID"
                        prop="orderid">
            <el-input v-model="search.orderid"
                      placeholder="请输入工单ID"
                      class="width-max"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           v-model="search.projectid"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目名称搜索"
                           :query-request="(_) => getProjectTable(Object.assign({customerid: search.customerid || null}, _))"
                           :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearchResult()">
            按搜索结果导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">复核列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="复核任务ID"
                         width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderid"
                         label="工单ID"
                         width="120">
          <template slot-scope="scope">
            <router-link :to="`/order/detail/${scope.row.orderid}`">
              <span style="color: rgb(88, 157, 248)">ORD{{ scope.row.orderid }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="title"
                         label="任务名称"
                         min-width="150"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <router-link :to="`/task/detail/${scope.row.taskid}`"
                         target="_blank">
              <span style="color: rgb(88, 157, 248)">{{ scope.row.title }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="projectname"
                         label="所属项目"
                         min-width="120"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.projectid">
              {{ scope.row.projectname }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchname"
                         label="所属批次"
                         min-width="120"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.batchid">
              {{ scope.row.batchname }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="salary"
                         label="赏金"
                         width="100">
          <template slot-scope="scope">
            {{ scope.row.salary }}
          </template>
        </el-table-column>
        <el-table-column prop="reviewedtime"
                         label="审核通过时间"
                         width="160">
          <template slot-scope="scope">
            {{ scope.row.reviewedtime }}
          </template>
        </el-table-column>
        <el-table-column prop="cityname"
                         label="城市"
                         width="100">
          <template slot-scope="scope">
            {{ scope.row.cityname }}
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
                         min-width="150"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.marketname }}
          </template>
        </el-table-column>
        <el-table-column label="工单审核人"
                         width="120">
          <template slot-scope="scope">
            {{ scope.row.reviewer_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="review_status"
                         label="复核状态"
                         width="100">
          <template slot-scope="scope">
            <el-tag :type="getReviewStatusTagType(scope.row.review_status)">
              {{ reviewStatusMap[scope.row.review_status] || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="adminname"
                         label="复核人"
                         width="120">
          <template slot-scope="scope">
            {{ scope.row.adminname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="review_complete_time"
                         label="复核完成时间"
                         width="160">
          <template slot-scope="scope">
            {{ scope.row.review_complete_time || '-' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="160">
          <template slot-scope="scope">
            <button-gutter>
              <router-link v-if="scope.row.review_status > 0"
                           :to="`/order/review-audit-quality-detail/${scope.row.orderid}`">
                <el-button type="primary"
                           size="small">
                  详情
                </el-button>
              </router-link>
              <router-link v-if="scope.row.review_status * 1 === 0"
                           :to="`/order/review-audit-quality/${scope.row.orderid}`">
                <el-button type="warning"
                           size="small">
                  去复核
                </el-button>
              </router-link>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import reviewTaskMixins from '@views/task/review-task.mixins.js'
import RemoteSelect from '@core/components/RemoteSelect.vue'
import ButtonGutter from '@core/components/ButtonGutter.vue'

export default {
  components: {ButtonGutter, RemoteSelect},
  mixins: [table, reviewTaskMixins],
  data () {
    return {
      search: {
        review_status: null,
        intern_user_id: null,
        adminid: null,
        customerid: null,
        reviewedtime_range: [],
        orderid: null,
        projectid: null,
      },
      searchFieldType: {
        adminid: Number,
        intern_user_id: Number,
        customerid: Number,
        orderid: Number,
        projectid: Number,
      },
    }
  },
  computed: {},
  created () {},
  methods: {
    ...Vuex.mapActions([
      'getProjectTable', 'getProjectDetail',
    ]),
    ...request.map([
      'getCustomerTable', 'getCustomerDetail',
      'getPlatformUsersIndex', 'getPlatformUsersDetail',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryReviewTaskTableApi', params)
    },
    /**
     * 获取复核状态标签类型
     * @param {Number} status
     */
    getReviewStatusTagType (status) {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'danger',
      }
      return typeMap[status] || 'info'
    },
    /**
     * 导出搜索结果
     */
    onExportSearchResult () {
      this.$export('工单复核列表', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data.forEach(item => {
            item.review_status = _.get(this.reviewStatusMap, item.review_status, item.review_status)
          })
          return data
        },
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
a {
  text-decoration: none;
}

.blue-color {
  color: rgb(88, 157, 248);
}

.el-tag {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/task/pages/ReviewTaskTable.vue